import request from '@/utils/request'

export function getScheduleList(params) {
  return request({
    url: `/api/admin/schedules/teachers/${params.teacherId}/weekly`,
    method: 'get',
    params
  })
}

export function getTeacherWeeklySchedule(teacherId, params) {
  return request({
    url: `/api/admin/schedules/teachers/${teacherId}/weekly`,
    method: 'get',
    params
  })
}

// Get teacher view of weekly schedule (teacher's own view)
export function getTeacherViewSchedule(teacherId, params) {
  return request({
    url: `/api/admin/schedules/teachers/${teacherId}/weekly/teacher-view`,
    method: 'get',
    params
  })
}

export function getUnavailableTime(params) {
  return request({
    url: '/api/admin/settings/getUnavailableTime',
    method: 'get',
    params
  })
}

export function setUnavailableTime(data) {
  return request({
    url: '/api/admin/settings/setUnavailableTime',
    method: 'post',
    data
  })
}

export function getWeekdays() {
  return request({
    url: '/api/admin/settings/weekdays',
    method: 'get'
  })
}

// Set weekdays
export function setWeekdays(data) {
  return request({
    url: '/api/admin/settings/weekdays',
    method: 'post',
    data
  })
}

// Weekly Calendar APIs
export function getWeeklyCalendarTemplates() {
  return request({
    url: '/api/admin/WeeklyCalendar',
    method: 'get'
  })
}

export function createWeeklyCalendarTemplate(data) {
  return request({
    url: '/api/admin/WeeklyCalendar',
    method: 'post',
    data
  })
}

export function updateWeeklyCalendarTemplate(dayOfWeek, data) {
  return request({
    url: `/api/admin/WeeklyCalendar/${dayOfWeek}`,
    method: 'put',
    data
  })
}

export function deleteWeeklyCalendarTemplate(dayOfWeek) {
  return request({
    url: `/api/admin/WeeklyCalendar/${dayOfWeek}`,
    method: 'delete'
  })
}
